import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTravellerStatusPaused(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10 9C11 9 11 10 11 10V14C11 14 11 15 10 15C9 15 9 14 9 14V10C9 10 9 9 10 9Z"
        fill="currentColor"
      />
      <path
        d="M14 9C15 9 15 10 15 10L15 14C15 14 15 15 14 15C13 15 13 14 13 14V10C13 10 13 9 14 9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
